import { Link } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  return (
    <div className="nf-page">
      <Link to="/" className="nf-logo">
        <img src="/logo.svg" alt="" className="nf-logo-icon" width="40" height="40" />
        <span className="al-logo">Numus</span>
      </Link>

      <main className="nf-main">
        <p className="nf-code" aria-hidden="true">
          <span className="al-em">404</span>
        </p>
        <h1 className="al-display nf-title">Page not found</h1>
        <p className="al-lead nf-copy">
          That link doesn&apos;t lead anywhere. Head home and pick up where you left off.
        </p>
        <Link to="/" className="al-btn al-btn--dark nf-cta">
          Back to home
        </Link>
      </main>
    </div>
  );
}

export default NotFound;
